// utils/pickup.ts

export const buildPickupItems = (selectedProducts: any[]) => {
    return selectedProducts.flatMap(p => {
        const isMultiVariant = p.variants && p.variants.length > 1;
        if (isMultiVariant) {
            return Object.entries(p._variant_quantities || {})
                .filter(([, qty]) => (qty as number) > 0)
                .map(([variantId, qty]) => ({
                    product_id: p.id,
                    product_variant_id: Number(variantId),
                    quantity: qty as number,
                }));
        }
        return [{
            product_id: p.id,
            product_variant_id: null,
            quantity: p._pickup_quantity ?? 0,
        }];
    });
};